module.exports = {"520628001":"大兴街道","520628002":"蓼皋街道","520628003":"世昌街道","520628004":"太平营街道","520628005":"九江街道","520628101":"盘石镇","520628102":"盘信镇","520628103":"大坪场镇","520628104":"普觉镇","520628105":"寨英镇","520628106":"孟溪镇","520628107":"乌罗镇","520628108":"甘龙镇","520628109":"长兴堡镇","520628110":"迓驾镇","520628112":"牛郎镇","520628113":"黄板镇","520628114":"平头镇","520628115":"大路镇","520628116":"木树镇","520628117":"冷水溪镇","520628118":"正大镇","520628203":"长坪乡","520628207":"妙隘乡","520628209":"石梁乡","520628210":"瓦溪乡","520628211":"永安乡","520628214":"沙坝河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520628.json
// module id = 2313
// module chunks = 0